export default __webpack_public_path__ + "static/media/balance.f68509b6.svg";